import type FormConfirmationProps from 'components/FormConfirmation/FormConfirmationProps';
import type EpiContent from 'types/EpiContent';

export type FormConfirmationContent = Pick<FormConfirmationProps, 'heading' | 'text' | 'blocks' | 'localization'> & {
    component: 'FormConfirmationBlock';
};

export const isFormConfirmationContent = (c: EpiContent | undefined): c is FormConfirmationContent =>
    !!c && c.component === 'FormConfirmationBlock';

export const getFormConfirmationContent = (
    formConfirmation: FormConfirmationContent[] | undefined,
): FormConfirmationContent | undefined => {
    if (!formConfirmation) return undefined;

    if (Array.isArray(formConfirmation)) {
        return formConfirmation.find(isFormConfirmationContent);
    }

    return isFormConfirmationContent(formConfirmation) ? formConfirmation : undefined;
};
